import modal from "./modal";
import ModalBody from "./modalBody";
import ModalFooter from "./modalFooter";
import ModalHeader from "./modalHeader";
import ModalSubtitle from "./modalSubtitle";
import ModalTitle from "./modalTitle";

export type { ModalProps } from "./modal";
export type { ModalBodyProps } from "./modalBody";
export type { ModalHeaderProps } from "./modalHeader";
export type { ModalTitleProps } from "./modalTitle";
export type { ModalFooterProps } from "./modalFooter";

const Modal = Object.assign(modal, {
  Body: ModalBody,
  Header: ModalHeader,
  Title: ModalTitle,
  Subtitle: ModalSubtitle,
  Footer: ModalFooter,
});

export default Modal;
